import ComingSoon from '../../../../components/ComingSoon';
import DashboardLayout from '../../../../layouts/DashboardLayout';

const EmpOnboard = () => {
  return (
    <DashboardLayout title="Onboard">
      <ComingSoon />
    </DashboardLayout>
  );
};

export default EmpOnboard;
